import React, { useEffect, useState } from "react";
import { embedSources } from '@assets/ts/videoEmbed';
import { VideoEmbed } from '@assets/tsx/videoEmbed';
export default function Video({ video: customVideo, rounded, thumbnail, source, prefetch }) {
    var _a, _b, _c, _d, _e, _f;
    const [playing, setPlaying] = useState(false);
    const [videoRef, setVideoRef] = useState(null);
    const [video, setVideo] = useState(() => determineSource(prefetch, source, customVideo));
    useEffect(() => {
        if (!videoRef)
            return;
        playing && videoRef.play();
    }, [playing]);
    useEffect(() => {
        setPlaying(false);
    }, [thumbnail]);
    useEffect(() => {
        setVideo(() => determineSource(prefetch, source, customVideo));
    }, [customVideo, source]);
    if (!((_a = video === null || video === void 0 ? void 0 : video.item) === null || _a === void 0 ? void 0 : _a.url))
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", { style: { textAlign: 'center', background: '#ececec' } }, "Pasirinkite video")));
    if (embedSources.includes(source)) {
        return React.createElement(VideoWrap, { rounded: rounded },
            React.createElement(VideoEmbed, { source: source, url: (_b = video === null || video === void 0 ? void 0 : video.item) === null || _b === void 0 ? void 0 : _b.url }));
    }
    if (embedSources.includes(video.source)) {
        return React.createElement(VideoWrap, { rounded: rounded },
            React.createElement(VideoEmbed, { source: video.source, url: (_c = video === null || video === void 0 ? void 0 : video.item) === null || _c === void 0 ? void 0 : _c.url }));
    }
    return (React.createElement(VideoWrap, { rounded: rounded },
        (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url) && !playing && (React.createElement("img", { className: "ltg-video-thumbnail", src: thumbnail.url, alt: thumbnail.alt || ((_d = video === null || video === void 0 ? void 0 : video.item) === null || _d === void 0 ? void 0 : _d.filename) })),
        ((_e = video === null || video === void 0 ? void 0 : video.item) === null || _e === void 0 ? void 0 : _e.url) && React.createElement("video", { className: "ltg-video", ref: setVideoRef, src: (_f = video === null || video === void 0 ? void 0 : video.item) === null || _f === void 0 ? void 0 : _f.url, controls: playing }),
        !playing && (React.createElement("div", { className: "ltg-video-play-wrap", onClick: () => { setPlaying(prev => !prev); } },
            React.createElement("div", { className: "ltg-video-play" },
                React.createElement("div", { className: "ltg-video-play-icon" },
                    React.createElement("i", { className: "fas fa-play" })),
                "\u017Di\u016Br\u0117ti video")))));
}
const VideoWrap = ({ rounded, children }) => {
    return React.createElement("div", { className: `ltg-video-wrap${rounded === 'none' ? '' : ` --rounded-${rounded || 'lg'}`}` }, children);
};
function determineSource(prefetch, source, customVideo) {
    let post_video;
    let post_video_source;
    if (typeof window === 'undefined') {
        post_video = prefetch === null || prefetch === void 0 ? void 0 : prefetch.featured_video;
        post_video_source = prefetch === null || prefetch === void 0 ? void 0 : prefetch.featured_video;
    }
    else {
        const { elementor } = window;
        post_video = (elementor === null || elementor === void 0 ? void 0 : elementor.getContainer) ? elementor.getContainer('document').getSetting('featured_video') : prefetch.featured_video;
        post_video_source = (elementor === null || elementor === void 0 ? void 0 : elementor.getContainer) ? elementor.getContainer('document').getSetting('featured_video_source') : prefetch.featured_video_source;
    }
    const video_data = {
        item: source === 'post' ? post_video : customVideo,
        source: post_video_source
    };
    return video_data;
}
